import { response } from 'express';
import {
  OnChanges,
  Component,
  Input,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import {SellService} from "@shared/services/api/sell.service";

@Component({
  selector: 'app-properties-preview',
  templateUrl: './properties-preview.component.html',
  styleUrls: ['./properties-preview.component.scss'],
})
export class PropertiesPreviewComponent implements OnInit, OnChanges {
  properties: any;
  locationIds: Array<any> = [];
  filter: any[] = [];
  @Input('cardAmount') cardAmount: any;
  @Input('page') page: any;
  @Input('lugar') lugar: any;
  @Output() cardsExist = new EventEmitter<any>();
  @ViewChild('typehead', { read: MatAutocompleteTrigger })
  autoTrigger: MatAutocompleteTrigger;
  constructor(private _sellService: SellService) {}

  ngOnInit(): void {}
  ngOnChanges(): void {
    this.locationIds = this.lugar ? this.lugar.ids : '';
    const query = {
      pagina: 1,
      pageSize: this.cardAmount,
      rangoRentabilidad: this.lugar ? '' : 5,
      ubicacion: this.lugar ? this.locationIds : '',
      prov: this.lugar ? this.lugar.prov : '',
      locationDescription: this.lugar ? this.lugar.locationDescription : '',
    };
    if (this.page === 'home' || this.lugar) {
      this._sellService.getPublications(query).subscribe((response) => {
        this.properties = response.data;
        if (this.properties.length > 0) {
          this.cardsExist.emit(true);
        } else {
          this.cardsExist.emit(false);
        }
      });
    }
  }

  onRefreshPage(publication: any) {
    window.open(
      'invertir/propiedad/' + publication.publicationSummary?.reference
    );
  }
}
